import React, { FC, useContext } from "react";
import { useTranslation } from "i18n";
import PriceInfoBlock from "../PriceInfoBlock";
import { addOnNamesMap } from "../../../constants";
import { IAddOns } from "../../../types";
import { BillingContext } from "../../../BillingContext";

type PriceInfoPropsType = {
  addOns: IAddOns[];
  planName: string;
  currencySymbol?: string;
  placeholderSubscription: any;
  isAnnual: boolean;
  triggerRefetch?: () => {};
  showButton?: boolean;
  title?: string;
  isReadOnlyAddon?: boolean;
};

const PriceInfo: FC<React.PropsWithChildren<PriceInfoPropsType>> = ({
  addOns,
  planName,
  currencySymbol,
  placeholderSubscription,
  isAnnual,
  triggerRefetch,
  showButton,
  title,
  isReadOnlyAddon,
}) => {
  const { toggleAddOnSelected } = useContext(BillingContext);

  const { t } = useTranslation();

  const editAddOnsSelection = (addOn: IAddOns) => {
    toggleAddOnSelected(addOn);

    triggerRefetch?.();
  };

  return (
    <div className="flex flex-col w-full gap-2">
      <PriceInfoBlock
        name={planName}
        currencySymbol={currencySymbol}
        value={placeholderSubscription?.amountValue || 0}
        priceSuffix={t("common:billing.label.plusVat")}
        title={
          title?.toUpperCase() ??
          t("common:billing.checkout.infoBox.subscription").toUpperCase()
        }
        paymentPeriod={t(
          isAnnual
            ? "common:billing.planSelector.addOns.price.annual"
            : "common:billing.planSelector.addOns.price.monthly"
        )}
        variant="primary"
      />
      {addOns.length > 0 &&
        addOns.map((addOn) => {
          return (
            <PriceInfoBlock
              currencySymbol={currencySymbol}
              value={addOn.amountValue}
              priceSuffix={t("common:billing.label.plusVat")}
              title={
                <span>
                  {t(addOnNamesMap[addOn.code]).toUpperCase()}{" "}
                  {isReadOnlyAddon && <span className="text-m">*</span>}
                </span>
              }
              name={
                isReadOnlyAddon && (
                  <span className="text-m">
                    {t("billing.checkoutStep.addonDescr")}
                  </span>
                )
              }
              paymentPeriod={t(
                isAnnual
                  ? "common:billing.planSelector.addOns.price.annual"
                  : "common:billing.planSelector.addOns.price.monthly"
              )}
              variant="secondary"
              key={addOn.code}
              icon={showButton ? "delete" : undefined}
              onIconClick={
                showButton ? () => editAddOnsSelection(addOn) : undefined
              }
            />
          );
        })}
      <p className="text-color-neutral-two">
        {t("common:performer.planSelector.price.asterisk.description")}
      </p>
    </div>
  );
};

export default PriceInfo;
